import PersianSupportNumericTextField from "Global/Components/UnEditableComponents/PersianSupportNumericTextField/PersianSupportNumericTextField";
import SingleReactHookFormWrapper from "Global/Components/Generators/SingleReactHookFormWrapper/SingleReactHookFormWrapper";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
import { GlobalContext } from "Global/Context/GlobalContextProvider";

const EnterVerificationCode = ({ control, formState }) => {
  const languageArray = useContext(GlobalContext)?.LanguageArray;
  return (
    <React.Fragment>
      <SingleReactHookFormWrapper
        element={
          <PersianSupportNumericTextField
            label={FindLangKey("login-input-auth-code", languageArray)}
            isEnglish={i18next?.language === "en"}
          />
        }
        control={control}
        errors={formState.errors}
        name="VerificationCode"
        isPassword={false}
        required={false}
      />
    </React.Fragment>
  );
};

export default EnterVerificationCode;
